<template>
  <div class="user-management-container">
    <div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="85px"
        class="demo-ruleForm"
      >
        <el-row :gutter="0">
          <el-col :span="5">
            <div class="grid-content bg-purple">
              <el-form-item label="客户:" prop="compId">
                <el-select
                  v-model="ruleForm.compId"
                  placeholder="请选择客户"
                  @change="companyValue"
                  @focus="focusForm"
                  allow-create
                  filterable
                  size="small"
                >
                  <el-option
                    v-for="item in companyData"
                    :key="item.Company_Id"
                    :label="item.CompName"
                    :value="item.Company_Id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="5">
            <div class="grid-content bg-purple">
              <el-form-item label="公司联系人:" prop="LinkMan">
                <el-select
                  v-model="ruleForm.LinkMan"
                  placeholder="请选择联系人"
                  @change="resetValue"
                  size="small"
                >
                  <el-option
                    v-for="item in LinkManData"
                    :key="item.id"
                    :label="item.LinkMan"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="5">
            <div class="grid-content bg-purple">
              <el-form-item label="联系人:" prop="LinkMan">
                <el-input v-model="ruleForm.LinkMan" size="small"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="5">
            <div class="grid-content bg-purple">
              <el-form-item label="联系电话:">
                <el-input v-model="ruleForm.TelNo" size="small"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="5">
            <div class="grid-content bg-purple">
              <el-form-item label="联系手机:" prop="Phone">
                <el-input v-model="ruleForm.Phone" size="small"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="5">
            <div class="grid-content bg-purple">
              <el-form-item label="地址:" prop="Address">
                <el-input v-model="ruleForm.Address" size="small"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="5">
            <div class="grid-content bg-purple">
              <el-form-item label="Email:" prop="Email" required>
                <el-input v-model="ruleForm.Email" size="small"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="4">
            <div class="grid-content bg-purple">
              <el-form-item label="传真:" prop="Fax">
                <el-input v-model="ruleForm.Fax" size="small"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="4">
            <div class="grid-content bg-purple">
              <el-form-item label="邮编:" prop="Post">
                <el-input v-model="ruleForm.Post" size="small"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="headerTitle">
      <div>维修登记</div>
      <div>
        <update-button @buttonClick="addPower"> 添加 </update-button>
        <add-button @buttonClick="submitForm('ruleForm')"> 提交 </add-button>
      </div>
    </div>
    <div
      class="claim_company"
      style="width: 100%; height: 100%; overflow: hidden"
    >
      <div
        style="
          width: 100%;
          height: 100%;
          position: relative;
          overflow: auto;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        "
        ref="tabelContainerDiv"
      >
        <el-table
          ref="tabel"
          class="tabel-panel-container"
          :border="true"
          size="small"
          height="500"
          max-height="500"
          :header-cell-class-name="headerClass"
          :header-cell-style="{ backgroundColor: '#6486e8' }"
          cell-class-name="cellClass"
          :data="tableData.list"
          :highlight-current-row="true"
        >
          <el-table-column prop="BrandName" align="center" label="品牌">
          </el-table-column>
          <el-table-column prop="ProductName" align="center" label="产品">
          </el-table-column>

          <el-table-column prop="ModelNoStr" align="center" label="型号">
          </el-table-column>

          <el-table-column prop="SerialNoName" align="center" label="SN">
            <template #default="scope">
              <div
                :style="{
                  color:
                    scope.row.Distinguish == 1
                      ? 'green'
                      : scope.row.Distinguish == 2
                      ? 'blue'
                      : scope.row.Distinguish == 3
                      ? 'red'
                      : '',
                }"
              >
                {{ scope.row.SerialNoName }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="AttachName" align="center" label="附件">
          </el-table-column>
          <el-table-column prop="CusApp" align="center" label="症状信息">
          </el-table-column>
          <el-table-column label="取消" align="center">
            <template #default="scope">
              <div class="opration">
                <del-button
                  class="item"
                  :useConfirm="true"
                  comfirmMessage="确定删除吗？"
                  comfirmOkText="确定"
                  comfirmCancelText="取消"
                  @buttonClick="delSingleUser(scope.$index, scope.row)"
                  >取消</del-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-pagination
      background
      :page-size="20"
      :total="tableData.count"
      :pager-count="pagerCount"
      prev-text="上一页"
      next-text="下一页"
      @current-change="pageChange"
      layout="total, prev, pager, next, jumper,slot"
      style="margin-top: 20px"
    >
      <template #default>
        <el-button size="mini" @click="createdInfo">刷新</el-button>
      </template>
    </el-pagination>
    <pop-dialog
      id="loadBOX"
      @confirmClick="listDataSave"
      v-if="loadShow"
      ref="getMenuList"
      :meta="popDialogList"
      detailShowType="data"
      @dialogClose="loadShow = false"
    >
      <template v-slot="idData">
        <div class="saveBox">
          <el-form
            :model="addListForm"
            :rules="rules"
            ref="addListForm"
            label-width="85px"
          >
            <el-row :gutter="0">
              <el-col :span="10">
                <div class="grid-content bg-purple">
                  <el-form-item label="品牌名称:" prop="BrandId">
                    <el-select
                      v-model="addListForm.BrandId"
                      placeholder="请选择品牌"
                      @change="addProductSelect"
                      size="small"
                    >
                      <el-option
                        v-for="item in BrandData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="10">
                <div class="grid-content bg-purple">
                  <el-form-item label="产品类别:" prop="ProductId">
                    <el-select
                      v-model="addListForm.ProductId"
                      placeholder="请选择产品类别"
                      @change="addModelSelect"
                      size="small"
                    >
                      <el-option
                        v-for="item in ProductData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="0">
              <el-col :span="10">
                <div class="grid-content bg-purple">
                  <el-form-item label="产品型号:" prop="ModelNoid">
                    <el-select
                      v-model="addListForm.ModelNoid"
                      placeholder="请选择产品型号"
                      filterable
                      size="small"
                    >
                      <el-option
                        v-for="item in modelData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="10">
                <div class="grid-content bg-purple">
                  <el-form-item label="SN号:" prop="SerialNoName">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 1 }"
                      v-model="addListForm.SerialNoName"
                      placeholder=""
                      size="small"
                    ></el-input>
                    <!-- @change="SNSearch" -->
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="2">
              <el-col :span="20">
                <div class="grid-content bg-purple">
                  <el-form-item label="附件:" prop="AttachInfoId">
                    <el-checkbox-group v-model="checkedList">
                      <el-checkbox
                        style="padding-right: 15px"
                        v-for="city in AttachData"
                        :label="city.id"
                        :key="city.id"
                        :value="city.Name"
                        @change="handleCheckedCitiesChange(city)"
                      >
                        {{ city.Name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="0">
              <el-col :span="10">
                <div class="grid-content bg-purple">
                  <el-form-item label="症状描述:" prop="ModelIllId">
                    <el-select
                      v-model="addListForm.ModelIllId"
                      placeholder="请选择症状"
                      @change="addModelIllID"
                      size="small"
                    >
                      <el-option
                        v-for="item in ModelIllData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="0">
              <el-col :span="20">
                <div class="grid-content bg-purple">
                  <el-form-item label="症状信息:" prop="CusApp">
                    <el-input
                      v-model="addListForm.CusApp"
                      placeholder=""
                      size="small"
                      @change="clearModelIllID"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="0">
              <el-col :span="20">
                <div class="grid-content bg-purple">
                  <el-form-item label="备注:" prop="IllDesc">
                    <el-input
                      v-model="addListForm.IllDesc"
                      placeholder=""
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </template>
    </pop-dialog>
  </div>
</template>

<script>
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import {
  CompanyInfoes,
  linkMan,
  RepairAddList,
  RepairDeleteList,
  SerApplyRepairCommits,
} from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";

export default {
  name: "RepairSerApply",
  components: {
    addButton,
    delButton,
    tabelPanel,
    popDialog,
    updateButton,
  },
  data() {
    return {
      pagerCount: 7,
      loadShow: false,
      // 公司数据
      companyData: null,
      LinkManData: null,
      // 添加信息列表
      BrandData: null,
      // 产品数据
      ProductData: null,
      modelData: null,
      AttachData: null,
      ModelIllData: null,
      CusAppArr: [],
      checkedList: [],
      checkedListId: [],
      checkedListArr: [],
      headerClass() {
        return "headerClass";
      },
      addListForm: {
        BrandId: null, // BrandId	int	品牌Id
        ProductId: null, // ProductId	int	产品Id
        CusApp: "", // CusApp	string	系统信息标注 /症状信息
        ModelNoid: null, // ModelNoid	int	型号Id
        ModelIllId: null, // ModelIllId	int	症状id
        SerialNoName: "", // SerialNoName	string	SN
        AttachInfoId: "", // AttachInfoId	string	附件Id
        AttachName: "", // AttachName	String	附件名称
        IllDesc: "", // IllDesc	string	备注
      },
      ruleForm: {
        LinkMan: "", // LinkMan	string	联系人	是
        compId: null, // compId	int	公司id	是
        Phone: "", // Phone	string	手机	是
        Address: "", // Address	string	地址	是
        Email: "", // Email	string	邮件
        Fax: "", // Fax	string	传真
        Post: "", // Post	string	邮编
        TelNo: "", // TelNo	string	联系电话	是
        list: [], // list	[]		是
      },
      rules: {
        LinkMan: [
          {
            required: true,
            trigger: ["blur", "change"],
          },
        ],
        compId: [
          {
            required: true,
            message: "请选择客户",
            trigger: "change",
          },
        ],
        TelNo: [
          {
            required: true,
            message: "请输入电话",
            trigger: ["blur", "change"],
          },
        ],
        Phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur", "change"],
          },
          {
            min: 11,
            max: 11,
            message: "长度在 11个字符",
            trigger: "blur",
          },
        ],
        Address: [
          {
            required: true,
            message: "请输入地址",
            trigger: ["blur", "change"],
          },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        // 品牌名称
        BrandId: [
          {
            required: true,
            message: "请选择品牌",
            trigger: "change",
          },
        ],
        // 产品型号
        ProductId: [
          {
            required: true,
            message: "请选择产品类别",
            trigger: "change",
          },
        ],
        // 产品型号
        ModelNoid: [
          {
            required: true,
            message: "请选择产品型号",
            trigger: "change",
          },
        ],
        // 产品型号
        SerialNoName: [
          {
            required: true,
            message: "请输入sn号",
            trigger: "change",
          },
        ],
        // 统标注信息
        CusApp: [
          {
            required: true,
            message: "请输入统标注信息",
            trigger: "change",
          },
        ],
        // 备注
        IllDesc: [
          {
            required: true,
            message: "请输入备注",
            trigger: "change",
          },
        ],
      },
      tableData: {},
    };
  },
  created() {
    this.createdInfo();
  },
  watch: {
    // 'addListForm.BrandId': {
    //     deep: true,
    //     handler: function () {
    //         this.addProductSelect()
    //         this.addModelSelect()
    //     }
    // }
  },
  methods: {
    // 初始化数据
    createdInfo() {
      //CompanyInfoes 过虑查询
      tableApi.CompanyInfo().then((data) => {
        if (data.code == 0) {
          this.companyData = data.data.list;
        } else {
          return console.log(data.code);
        }
      });

      tableApi.RepairSelect().then((data) => {
        if (data.code == 0) {
          this.tableData = data.data;
        } else {
          return console.log(data.code);
        }
      });

      tableApi.BrandSelect().then((data) => {
        if (data.code == 0) {
          this.BrandData = data.data.list;
        } else {
          return console.log(data.code);
        }
      });
    },
    //联系人
    companyValue() {
      let Company_Id = this.ruleForm.compId;
      if (Company_Id === null) {
        return;
      } else {
        linkMan({ Company_Id }).then((data) => {
          if (data.code == 0) {
            this.LinkManData = data.data.list;
          } else {
            return console.log(data.message);
          }
        });
      }
    },
    focusForm() {
      this.resetForm("ruleForm");
    },
    resetValue(row) {
      let linkData = this.LinkManData.find((item) => {
        if (item.id === row) {
          return item;
        }
      });
      this.ruleForm.LinkMan = linkData.LinkMan || "";
      this.ruleForm.Address = linkData.Address || "";
      this.ruleForm.Email = linkData.Email || "";
      this.ruleForm.Phone = linkData.Phone || "";
      this.ruleForm.TelNo = linkData.TelNo || "";
      this.ruleForm.Fax = linkData.Fax || "";
      this.ruleForm.Post = linkData.Post || "";
      console.log("ruleForm:", this.ruleForm);
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          console.log("ruleForm:", this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    delSingleUser(index, row) {
      console.log(index, row);
      let id = row.id;
      RepairDeleteList({ id }).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.createdInfo();
        } else {
          errMsg(data.message);
        }
      });
    },
    //分页
    pageChange() {
      console.log(123);
    },
    // 提交信息
    submitForm(formName) {
      let sels = this.$refs.tabel.data;
      console.log(sels);
      if (sels.length === 0) {
        return errMsg("没有数据");
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let ocmmitData = this.ruleForm;
          ocmmitData.list = sels;
          console.log("ocmmitData:", ocmmitData);
          SerApplyRepairCommits(ocmmitData).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.createdInfo();
            } else {
              errMsg(data.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 添加列表
    addPower() {
      let id = 0;
      this.loadShow = true;
      this.celarPop();
      // this.$nextTick(() => {
      //     this.$refs.getMenuList.showPopDialog(
      //         {id},
      //         "维修设备信息添加",
      //         "slot"
      //     )
      // })
    },
    addProductSelect() {
      let Bid = this.addListForm.BrandId;
      tableApi.ProductSelect({ Bid }).then((data) => {
        if (data.code == 0) {
          this.ProductData = data.data.list;
        } else {
          return errMsg(data.message);
        }
      });
    },
    addModelSelect() {
      let ProductCategoryId = this.addListForm.ProductId;
      tableApi.modelSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.modelData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
      this.addAttachSelect();
      this.addModelIllSelect();
    },
    addAttachSelect() {
      let ProductCategoryId = this.addListForm.ProductId;

      tableApi.AttachSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.AttachData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    addModelIllSelect() {
      let ProductCategoryId = this.addListForm.ProductId;
      tableApi.ModelIllSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.ModelIllData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 添加标注信息
    addModelIllID(val) {
      let obj = {};
      obj = this.ModelIllData.find(function (item) {
        return item.id === val;
      });
      this.CusAppArr.push(obj.Name);
      this.addListForm.CusApp = this.CusAppArr.toString();
    },
    clearModelIllID() {
      this.CusAppArr = [];
      this.addListForm.CusApp = "";
    },
    // 附件折分id、Name
    handleCheckedCitiesChange(value) {
      console.log("value--", value);
      this.checkedListId.push(value.id);
      this.addListForm.AttachInfoId = this.checkedListId.toString();
      this.addListForm.AttachName = this.checkedListArr.toString();
      console.log("this.checkedList---", this.checkedList);
    },
    // 保存列表
    listDataSave({ slotData }) {
      let RepairSaveData = this.addListForm;
      if (RepairSaveData.ModelNoid == null) {
        errMsg("型号不能为空");
        return;
      }
      if (RepairSaveData.SerialNoName == "") {
        errMsg("SN号不能为空");
        return;
      }
      if (RepairSaveData.ModelIllId == "") {
        errMsg("症状不能为空");
        return;
      }
      if (RepairSaveData.CusApp == "") {
        errMsg("统标注信息不能为空");
        return;
      }
      if (RepairSaveData.IllDesc == "") {
        errMsg("备注不能为空");
        return;
      }

      let stingArr = this.checkedList.toString();
      RepairSaveData.AttachInfoId = stingArr;
      RepairSaveData.id = slotData.id;
      console.log("#", RepairSaveData);
      RepairAddList(RepairSaveData).then((data) => {
        if (data.code == 0) {
          this.loadShow = false;
          successMsg(data.message);
          this.createdInfo();
          this.clearableFrom();
          this.$refs["addListForm"].resetFields();
        } else {
          errMsg(data.message);
        }
      });
    },
    clearableFrom() {
      this.checkedList = [];
      this.addListForm.SerialNoName = "";
      this.addListForm.AttachInfoId = "";
      this.addListForm.AttachName = "";
    },
    //重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    SNSearch(v) {
      console.log(v);
      tableApi.SearchCusApplyRepairBySN({ sns: v }).then((data) => {
        if (data.code == 0) {
          let sn = data.data.list;
          this.addListForm.BrandId = sn.BrandId;
          this.addListForm.ProductId = sn.ProCateId;
          this.addListForm.ModelNoid = sn.ModelNoId;
          this.addListForm.ModelIllId = null;
          this.addListForm.CusApp = "";
          this.addListForm.IllDesc = "";
          this.CusAppArr = [];
          this.checkedList = [];
          this.addProductSelect();
          this.addModelSelect();
        } else {
          errMsg(data.message);
          // this.addListForm.BrandId = null;
          // this.addListForm.ProductId = null;
          // this.addListForm.ModelNoid = null;
          // this.AttachData = null;
        }
      });
    },
    celarPop() {
      this.clearModelIllID();
      this.addListForm = {
        BrandId: null, // BrandId	int	品牌Id
        ProductId: null, // ProductId	int	产品Id
        CusApp: "", // CusApp	string	系统信息标注
        ModelNoid: null, // ModelNoid	int	型号Id
        ModelIllId: null, // ModelIllId	int	症状id
        SerialNoName: "", // SerialNoName	string	SN
        AttachInfoId: "", // AttachInfoId	string	附件Id
        AttachName: "", // AttachName	String	附件名称
        IllDesc: "", // IllDesc	string	备注
      };
      this.AttachData = null;
      this.checkedList = [];
      this.checkedListId = [];
      this.checkedListArr = [];
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/base.scss";
.el-table__header-wrapper,
.el-table__header-wrapper {
  background-color: red !important;
}
.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-content: center;

  .demo-ruleForm {
    margin-bottom: 20px;
    padding-top: 18px;
    border: rgba(0, 0, 0, 0.2) 1px solid !important;
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);

    .el-col {
      margin-bottom: 16px;
    }
  }
  .headerTitle {
    // background: grey;
    width: 100%;
    display: flex;
    padding: 5px 0;
    line-height: 20px;
    justify-content: space-between;
    font-family: hanSan;
    color: #6486e8;

    > div {
      display: flex;

      .update-button {
        margin-right: 10px;
      }
    }
  }
  .claim_company {
    .el-table {
      overflow: auto;
    }
    .el-table__body-wrapper,
    .el-table__header-wrapper,
    .el-table__footer-wrapper {
      overflow: visible;
    }
    .el-table::after {
      position: relative !important;
    }
  }
  .tabel-panel-container {
    width: 100%;
    border: rgb(100, 134, 232) 1px solid;
    border-radius: 4px;
    height: 100% !important;
    color: #505050;

    &:deep(.headerClass) {
      height: 100%;
      width: 100%;
      text-align: center;
      // @include background_color("tabel-header-bg-color");
      background: rgb(100, 134, 232);
      height: 40px;
      // @include border_right("tabel-header-border-right");
      box-sizing: border-box;
      color: #fff;
      // @include font_color("tabel-row-font-color");
      .el-table th,
      .el-table tr {
        background-color: red;
      }
    }

    &:deep(.cellClass) {
      font-size: 16px;
      font-family: hanSan;
      text-align: center;
      color: rgb(80, 80, 80);
      // @include font_family("font_family");
      // @include font_color("tabel-row-font-color");
      height: 40px;
      // @include border_bottom("tabel-row-border-bottom");
      // @include border_right("tabel-row-border-right");
    }

    .opration {
      display: flex;
      justify-content: center;
    }
  }

  #loadBOX .el-row {
    margin-bottom: 16px;
  }
}
.el-select-dropdown__item {
  padding: 0 10px;
}
::v-deep .el-form-item__content {
  // margin-left: -85px;
}

::v-deep .el-form-item__label {
  width: 85px;
  color: black;
  font-size: 14px;
  font-family: hanSan !important;
}
::v-deep table {
  background-color: #6486e8;
}
</style>
